import { useEffect, useState } from 'react';
import './index.scss';
import { NavBar, InfiniteScroll, PullToRefresh, Skeleton, Toast } from 'antd-mobile';
import http from '../../utils/request';
import { useNavigate } from 'react-router-dom';

export default function Album() {
  const [queryData, setQueryData] = useState<any[]>([]); // 查询到的数据
  const [total, setTotal] = useState(0); // 总条数
  const [page, setPage] = useState(1); // 当前页码
  const [loading, setLoading] = useState(true); // 骨架屏状态
  const [hasMore, setHasMore] = useState(true); // 是否还有更多数据
  const navigate = useNavigate();

  const PAGE_SIZE = 10; // 定义每页大小常量

  useEffect(() => {
    queryFunc(1, true); // 初始化加载第一页数据
  }, []);

  // 查询数据的函数
  const queryFunc = async (page: number, isRefresh = false) => {
    try {
      setLoading(true);
      const res = await http.get<any, any>('ContactInformation/query', {
        params: { page, size: PAGE_SIZE },
      });

      if (res.code === 0) {
        const newData = res.data; // 假设后端返回的数据已经是正确格式
        setQueryData((prevData) => {
          const updatedData = isRefresh ? newData : [...prevData, ...newData];
          console.log('Page:', page, 'New data length:', newData.length, 'Total data length:', updatedData.length); // 调试用
          return updatedData;
        });
        setTotal(res.total);

        // 判断是否还有更多数据
        const totalPages = Math.ceil(res.total / PAGE_SIZE);
        setHasMore(page < totalPages);
      } else {
        setHasMore(false); // 接口返回失败时停止加载
      }
    } catch (error) {
      console.error('加载数据失败:', error);
      setHasMore(false); // 出错时停止加载
    } finally {
      setLoading(false); // 关闭骨架屏
    }
  };

  // 下拉刷新的函数
  const handleRefresh = async () => {
    setPage(1);
    setHasMore(true);
    await queryFunc(1, true);
  };

  // 加载更多数据的函数
  const loadMore = async () => {
    if (!hasMore) return; // 如果没有更多数据，直接返回

    const nextPage = page + 1;
    setPage(nextPage);
    await queryFunc(nextPage);
  };

  // 复制微信号
  const handleCopy = (wechatId: string) => {
    navigator.clipboard
      .writeText(wechatId)
      .then(() => {
        Toast.show('微信号已复制');
      })
      .catch(() => {
        Toast.show('复制失败，请重试');
      });
  };

  return (
    <div className="phone">
      <NavBar onBack={() => navigate(-1)}>联系博主</NavBar>
      <PullToRefresh onRefresh={handleRefresh}>
        <div className="contentBox">
          {loading && queryData.length === 0 ? (
            Array.from({ length: 3 }).map((_, index) => (
              <div className="contentItem skeleton" key={index}>
                <Skeleton animated style={{ width: '100%', height: '200px', marginBottom: '10px' }} />
                <Skeleton animated style={{ width: '60%', height: '20px' }} />
              </div>
            ))
          ) : (
            queryData.map((item: any, index: number) => (
              <div className="contentItem" key={index}>
                <div className="imgBox">
                  <img src={'http://175.27.130.210:8091' + item.imgUrl} alt="" />
                </div>
                <div className="detailsBox">
                  <div className="title">{item.title}</div>
                  <div className="description">{item.description}</div>
                  <div className="wechatBox">
                    <span className="wechatId">{item.wechatNumber}</span>
                    <button className="copyBtn" onClick={() => handleCopy(item.wechatNumber)}>
                      复制
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
          <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        </div>
      </PullToRefresh>
    </div>
  );
}